import { render, staticRenderFns } from "./custom_information.vue?vue&type=template&id=f46850ca&scoped=true&"
import script from "./custom_information.vue?vue&type=script&lang=js&"
export * from "./custom_information.vue?vue&type=script&lang=js&"
import style0 from "./custom_information.vue?vue&type=style&index=0&id=f46850ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46850ca",
  null
  
)

export default component.exports